// extracted by mini-css-extract-plugin
export default {"background":"Customers_background__49hom","row":"Customers_row__NMchJ","col":"Customers_col__8DGTC","card":"Customers_card__ZroDE"};